export function getQueryParamValue(
  raw: string | (string | null)[] | null | undefined,
  defaultValue: string
): string {
  const value = Array.isArray(raw) ? raw[0] : raw;
  return value ?? defaultValue;
}
